import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { IServiceTypeInputModel } from "../../../../nomenclatures/serviceType/models/serviceTypeInputModel";

export const useEmployeeServices = (employeeId: number) => {
  const { data: services } = useApiQuery<IServiceTypeInputModel[]>({
    queryKey: [endpointsMetadata.employee.getEmployeeServices, employeeId],
    endpoint: `${endpointsMetadata.employee.getEmployeeServices}?employeeId=${employeeId}`,
    globalIsLoading: false,
  });

  return {
    services,
  };
};
